module.exports = __webpack_public_path__ + "static/media/phone.123b23f5.svg";